// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"LinkListItem_componentStyle__Mz5GX","icon":"LinkListItem_icon__5Zx9w","iconTextWrapper":"LinkListItem_iconTextWrapper__bZS_Y","badge":"LinkListItem_badge__UNScZ"};